export function setSourceUrl(src) {
  return "https://aixuebang-1310518323.file.myqcloud.com" + src;
}
function randomNum(min, max) {
  return parseInt(Math.random() * (max - min) + min);
}
export function getRandom(min, max, num) {
  let _num = randomNum(min, max);
  if (_num == num) {
    _num = getRandom(min, max, num);
  }
  return _num;
}
export function acountTime() {
  clearInterval(this.timer);
  let i = 0;
  this.timer = setInterval(() => {
    i++;
    let second = i % 60 < 10 ? `0${i % 60}` : i % 60;
    let minute =
      parseInt(i / 60) < 10 ? `0${parseInt(i / 60)}` : parseInt(i / 60);
    return `${minute}:${second}`;
  }, 1000);
}
export function computeQuestion(str, tags = ["（", "）"]) {
  let reg1 = new RegExp(`${tags[0]}`, "g");
  let reg2 = new RegExp(`${tags[1]}`, "g");
  let _str1 = str.replace(reg1, "|");
  let _str2 = _str1.replace(reg2, "|");
  let _str3 = _str2.split("</p>");

  let arr = [];
  let arr1 = [];

  for (let i = 0; i < _str3.length - 1; i++) {
    let _s = _str3[i].replace(/<\/?.+?>/g, "").replace(/ /g, "");
    arr.push(_s);
  }

  let _qnum = 0;
  for (let i = 0; i < arr.length; i++) {
    let sarr = arr[i].split("|");
    let iarr = [];
    for (let j = 0; j < sarr.length; j++) {
      let _i = {
        status: false,
        text: sarr[j].replace("@", ""),
      };
      if (-1 < sarr[j].indexOf("@")) {
        _i.recite = true;
        _i.isRecite = true;
        _i.qnum = ++_qnum;
      } else {
        _i.recite = false;
        _i.isRecite = false;
      }
      iarr.push(_i);
    }
    arr1.push(iarr);
  }
  return arr1;
}

// 防抖
export function debounce(fun, delay) {
  return function (args) {
    let that = this;
    let _args = args;
    clearTimeout(fun.id);
    fun.id = setTimeout(function () {
      fun.call(that, _args);
    }, delay);
  };
}
// 节流
export function throttle(fun, delay) {
  let last, deferTimer;
  return function (args) {
    let that = this;
    let _args = args;
    let now = +new Date();
    if (last && now < last + delay) {
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fun.apply(that, _args);
      }, delay);
    } else {
      last = now;
      fun.apply(that, _args);
    }
  };
}
export function checkPhone(tel) {
  let telReg = /^1[3-9]\d{9}$/;
  if (!tel) {
    return false;
  }
  if (!telReg.test(tel)) {
    return false;
  } else {
    return true;
  }
}
export function html2string(html) {
  html = String(html);
  return html.replace(/<\/?.+?>/g, "").replace(/ /g, "");
}
export function removeSpace(str) {
  str = str.replace(/\s*/g, "");
  return str;
}
export function deepClone(target) {
  function clone(target, map = new WeakMap()) {
    let result;
    const type = Object.prototype.toString.call(target).match(/\s(\w+)\]/)[1];

    if (typeof target !== "object" || target === null) {
      // 基本数据类型
      result = target;
    } else {
      if (["Array", "Set", "Map", "Object", "Arguments"].includes(type)) {
        // 可递归遍历的类型处理
        // 循环引用处理
        if (map.get(target)) {
          result = map.get(target);
        } else {
          const Constr = target.constructor;
          result = new Constr();
          map.set(target, result);

          if (type === "Array") {
            // Array
            target.forEach((v) => {
              result.push(clone(v, map));
            });
          } else if (type === "Set") {
            // Set
            target.forEach((v) => {
              result.add(clone(v, map));
            });
          } else if (type === "Map") {
            // Map
            target.forEach((v, k) => {
              result.set(k, clone(v, map));
            });
          } else {
            // Object Arguments
            Object.keys(target).forEach((k) => {
              result[k] = clone(target[k], map);
            });
          }
        }
      } else {
        // 不可递归遍历的类型处理
        const Constr = target.constructor;
        if (type === "RegExp") {
          // RegExp
          result = new Constr(target.source, /\w*$/.exec(target));
          result.lastIndex = target.lastIndex;
        } else if (type.includes("Function")) {
          // Function AsyncFunction GeneratorFunction
          result = target;
        } else if (["Date"].includes(type)) {
          // Date
          result = new Constr(target);
        } else if (type === "Error") {
          // Error
          result = new Constr(target.message);
          result.stack = target.stack;
        } else if (type === "URL") {
          // URL
          result = new Constr(target.href);
        } else if (type.includes("Array")) {
          // ArrayBuffer TypeArray BigArray ...
          result = target.slice();
        } else if (type === "DataView") {
          // DataView
          result = new Constr(
            target.buffer.slice(0),
            target.byteOffset,
            target.byteLength
          );
        } else {
          try {
            // 包装过的 Number String Symbol BigInt
            const val = Constr.prototype.valueOf.call(target);
            result = Object(val);
          } catch (err) {
            // other
            console.warn(`Uncatched type：${type}`);
            console.warn(err);
          }
        }
      }
    }
    return result;
  }

  const res = clone(target);
  return res;
}
export const setQuestion = [
  "课后练兵",
  "单元检测",
  "期中考试",
  "期中测试",
  "期末考试",
  "期末测试",
];
export function computeOptionjson(str, tag) {
  //格式化 选择题选项
  if (str) {
    let optionsValues = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    let option = [];
    let optionjson = str.match(/<li>(.+?)<\/li>/g);
    if (tag && tag != "") {
      tag = tag.replace(/\s+/g, "");
      if (optionjson) {
        Object.keys(optionjson).forEach((item) => {
          let text = optionjson[item];
          text = text.replace(new RegExp("<li>", "g"), "");
          text = text.replace(new RegExp("</li>", "g"), "");
          option.push({
            text: middleImg(formatImg(text)),
            value: setMathBa(optionsValues[item]),
            status: 0,
          });
        });
      }
    } else {
      if (optionjson) {
        Object.keys(optionjson).forEach((item) => {
          let text = optionjson[item];
          text = text.replace(new RegExp("<li>", "g"), "");
          text = text.replace(new RegExp("</li>", "g"), "");
          option.push({
            text: middleImg(formatImg(text)),
            value: optionsValues[item],
            status: 0,
          });
        });
      }
    }

    return option;
  }
}

export function formatAddPointWords(val) {
  let content = val || "";
  if (-1 < content.indexOf("{") && -1 < content.indexOf("}")) {
    let mobiaozi = content.match(/{(.+?)}/g);
    let words = "";
    for (let i = 0; i < mobiaozi.length; i++) {
      let word = mobiaozi[i];
      let str = "";
      if (1 < word.length) {
        for (let j = 0; j < word.length; j++) {
          str = str + `<span class="mubiaozi">${word[j]}</span>`;
        }
        content = content.replace(mobiaozi[i], str);
      } else {
        words = words + word;
      }
    }
    if (words.length) {
      for (let i = 0; i < words.length; i++) {
        content = content.replace(
          words[i],
          `<span class="mubiaozi">${words[i]}</span>`
        );
      }
    }
  }
  content = content.replace(
    new RegExp('<span class="mubiaozi">{</span>', "g"),
    ""
  );
  content = content.replace(
    new RegExp('<span class="mubiaozi">}</span>', "g"),
    ""
  );
  return content;
}

export function formatImg(str) {
  if (!str) {
    return false;
  }
  let imgReg = /<img.*?(?:>|\/>)/gi;
  let arr = str.match(imgReg);
  if (arr) {
    for (let i = 0; i < arr.length; i++) {
      let item = arr[i];
      if (-1 < item.indexOf("data-latex")) {
        let dataReg = /data-latex=['"]?([^'"]*)['"]?/i;
        let latex = item.match(dataReg)[1];
        str = str.replace(
          item,
          '<i class="math-formula" id="math-formula' +
            i +
            '" style="display: inline-flex; margin-right:.2rem">$$$$' +
            latex +
            "$$$$</i>"
        );
      }
    }
  }

  return str;
}
export function setMathBa(str) {
  str = str || "";
  str = str.replace(
    new RegExp("&lt;x拔&gt;", "g"),
    '<span class="math-ba">x</span>'
  );
  return str;
}

export function middleImg(str) {
  let content = String(str || "");
  let content1 = content.replace(/&lt;cimg&gt;/g, '<span class="cimg">');
  let content2 = content1.replace(/&lt;\/cimg&gt;/g, "</span>");
  return content2;
}

export function palindrome(str) {
  let reg = new RegExp(/([,.!?，。！？])/, "g");
  if (reg.test(str)) {
    return false;
  } else {
    return true;
  }
}

export function removeTags(html) {
  html = String(html);
  return html.replace(/<\/?.+?>/g, "");
}